<template>
<div class="col-12 table-container">
    <div class="headed-table p-0">
        <table class="table">
            <thead style="position: sticky; top: 0">
                <tr>
                    <th v-if="title">{{ title }}</th>
                    <th>Training Certificates</th>
                    <th>Plant & Tools</th>
                    <th>Toolbox Talks</th>
                    <th>Expired</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(user, rowIndex) in users_list"
                    :key="rowIndex"
                >
                    <td>
                        <div class="people-list--item-title">
                            <h5 class="people-list--item-title-name">{{ user.full_name }}</h5>
                            <h6 class="people-list--item-title-email">{{ user.email }}</h6>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center">
                            <div class="badge badge--sm badge--primary">
                                {{ user.total_amount_active_certificates }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center">
                            <div class="badge badge--sm badge--primary">
                                {{ user.total_amount_active_tools_on_site }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center">
                            <div class="badge badge--sm badge--primary">
                                {{ user.total_amount_toolbox_talks_submissions }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center">
                            <div
                                class="badge badge--sm"
                                :class="user.total_amount_expired_forms > 0
                                        ? 'badge--negative'
                                        : 'badge--secondary'
                                    "
                            >
                                {{ user.total_amount_expired_forms }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-around">
                            <div class="btn-group">
                                <svg-image
                                    :src="'/svg/' + resource_group + '/more.svg'"
                                    width="20px"
                                    height="25px"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                ></svg-image>
                                <div
                                    v-if="user?.inactive_at"
                                    class="dropdown-menu dropdown-menu-right"
                                >
                                    <svg-image
                                        v-if="disable_url"
                                        :key="`${user.id}_enable`"
                                        :src="'/svg/' + resource_group + '/tick.svg'"
                                        width="20px"
                                        height="20px"
                                        highlight="success"
                                        class="dropdown-item"
                                        :auto_hover="true"
                                        :spaced="true"
                                        v-on:click="disableOrActivateUser(user)"
                                    >
                                        <span class="text-danger">Activate</span>
                                    </svg-image>
                                </div>
                                <div
                                    v-else
                                    class="dropdown-menu dropdown-menu-right"
                                >
                                    <svg-image
                                        v-if="delete_url"
                                        :key="`${user.id}_delete`"
                                        :src="'/svg/' + resource_group + '/bin.svg'"
                                        width="20px"
                                        height="20px"
                                        highlight="danger"
                                        class="dropdown-item"
                                        :auto_hover="true"
                                        :spaced="true"
                                        v-on:click="deleteUser(user)"
                                    >
                                        <span class="text-danger">Remove</span>
                                    </svg-image>
                                    <svg-image
                                        v-if="disable_url"
                                        :key="`${user.id}_disable`"
                                        :src="'/svg/' + resource_group + '/close.svg'"
                                        width="20px"
                                        height="20px"
                                        highlight="danger"
                                        class="dropdown-item"
                                        :auto_hover="true"
                                        :spaced="true"
                                        v-on:click="disableOrActivateUser(user)"
                                    >
                                        <span class="text-danger">Disable</span>
                                    </svg-image>
                                </div>
                            </div>
                            <div
                                v-if="active"
                                v-on:mouseenter="hover = rowIndex"
                                v-on:mouseleave="hover = null"
                                v-on:click="active ? showUser(user) : ''"
                                v-bind:class="active ? 'cursor-pointer' : ''"
                                class="flex-table--cell flex-table--cell-break-50"
                            >
                                <svg-image
                                    v-if="active"
                                    :id="'showUser' + user.id"
                                    :src="'/svg/' + resource_group + '/edit.svg'"
                                    width="20px"
                                    height="25px"
                                    color="light-grey"
                                    highlight="primary"
                                    :hover="hover === rowIndex"
                                ></svg-image>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
export default {
    name: 'Table',
    props: {
        active: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '',
        },
        show: {
            type: Boolean,
            default: true,
        },
        load_url: null,
        search: null,
        role: null,
        edit_url: null,
        disable_url: null,
        delete_url: null,
    },
    data() {
        return {
            users_list: [],
            hover: null,

            loading: false,
        };
    },
    beforeMount() {
        this.users_list = this.role.users;
    },
    methods: {
        load() {
            let _this = this;

            if (_this.loading) {
                return;
            }

            _this.loading = true;

            axios
                .post(_this.load_url, {
                    search: _this.search,
                    role_id: _this.role.id,
                })
                .then(function (response) {
                    _this.loading = false;

                    const responseUserIds = new Set(response.data.map((user) => user.id));
                    const userListFiltered = _this.role.users.filter((user) =>
                        responseUserIds.has(user.id),
                    );

                    const userListFilteredIds = new Set(userListFiltered.map((user) => user.id));
                    const otherUsersList = response.data.filter(
                        (user) => !userListFilteredIds.has(user.id),
                    );

                    _this.users_list = [...userListFiltered, ...otherUsersList];
                })
                .catch(function (error) {
                    _this.loading = false;
                });
        },

        deleteUser(user) {
            if (!confirm(`Are you sure you want to remove ${user.full_name} from this company?`))
                return;

            axios
                .delete(this.delete_url.replace('?', user.id))
                .then(() => window.location.reload())
                .catch((error) => {
                    if (error.response) {
                        Vue.$toast.open({
                            message: error.response.data.message,
                            type: 'error',
                        });
                    }
                });
        },

        disableOrActivateUser(user) {
            if (user.inactive_at) {
                if (!confirm(`Are you sure you want to activate ${user.full_name}'s account?`))
                    return;
            } else {
                if (!confirm(`Are you sure you want to disable ${user.full_name}'s account?`))
                    return;
            }

            axios
                .post(this.disable_url.replace('?', user.id))
                .then(() => window.location.reload())
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Something went wrong',
                        type: 'error',
                    });
                });
        },

        showUser(user) {
            window.location.href = this.edit_url.replace('?', user.id);
        },

        getExpiredCertificates(certificates) {
            let expired_certificates = [],
                date = new Date();

            certificates.forEach(function (certificate) {
                if (Date.parse(certificate.expires_at) < date) {
                    expired_certificates.push(certificate);
                }
            });

            return expired_certificates;
        },
    },

    watch: {
        search() {
            if (this.search) {
                this.load();
            } else {
                this.users_list = this.role.users;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.table-container {
    border: 1px solid #f0f2f5;
    margin-bottom: 1rem;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0.5px 1px 1px #cdd9e9;
}

.headed-table {
    // max-height: 70vh;
    width: 100%;

    thead {
        border-radius: 10px;
        background-color: white;
        z-index: 1;

        th {
            border-top: none !important;
            min-width: 8rem !important;
            justify-content: center;
            text-align: center;
        }

        th:first-child {
            justify-content: start;
            text-align: start;
        }
    }

    tr {
        min-width: 8rem !important;
        justify-content: center;
        text-align: center;

        td {
            justify-content: center;
        }

        td:first-child {
            min-width: 18rem;
            justify-content: start;
            text-align: start;
        }
    }
}
</style>
